import axios from "axios";
import { T, APIS } from "../../Constants";

const { API_URL } = APIS;

//#region Types
type GetUsers = (params: { includeAdmin?: boolean, includeSelf?: boolean }) => T.AxiosPromise<T.UserType[]>;
//#endregion

export const getUsers: GetUsers = params => axios.post(API_URL + "getUsers", params);